import { Injectable } from '@angular/core';
import {ConceptsContainer} from '../../core/definitions/concepts-container';
import {Concept} from '../../core/definitions/concepts';
import {
  AdminEditItemComponent,
} from '../admin-lists/admin-edit-item/admin-edit-item.component';
import {MatDialog} from '@angular/material/dialog';
import {ConceptDialogData} from '../../core/concept.service';
import {KulturNavImporterDialogComponent} from '../../shared/kultur-nav-importer-dialog/kultur-nav-importer-dialog.component';

export interface OpenConceptParams {
  conceptsContainer: ConceptsContainer;
  concept: Concept;
  concept_id: string;
  index: number;
  callback;
}

@Injectable({
  providedIn: 'root'
})
export class ConceptDialogService {

  constructor(private readonly modalService: MatDialog) { }

  openConcept(params: OpenConceptParams) {
    const modalRef = this.modalService.open(AdminEditItemComponent, {
      panelClass: 'edit-dialog',
      disableClose: true,
      data: {
        conceptDataSource: params.conceptsContainer.conceptDataSource,
        conceptList: params.conceptsContainer.conceptDataSource.data,
        conceptsParams: params.conceptsContainer.conceptsParams,
        conceptType: params.conceptsContainer.conceptType,
        concept: params.concept,
        concept_id: params.concept_id,
        index: params.index
      } as ConceptDialogData
    });
    modalRef.afterClosed().subscribe((edited: boolean) => {
      if (params.callback) {
        params.callback(edited);
      }
    });
  }

  openKulturNavImporter(conceptsContainer: ConceptsContainer, callback) {
    const modalRef = this.modalService.open(KulturNavImporterDialogComponent, {
      panelClass: 'edit-dialog',
      autoFocus: false,
      data: {
        conceptType: conceptsContainer.conceptType
      } as ConceptDialogData
    });
    modalRef.afterClosed().subscribe((hadImports: boolean) => {
      callback(hadImports);
    });

  }
}
